import { render } from "./PlenumSelector.vue?vue&type=template&id=489ea91a&scoped=true"
import script from "./PlenumSelector.vue?vue&type=script&lang=js"
export * from "./PlenumSelector.vue?vue&type=script&lang=js"

import "./PlenumSelector.vue?vue&type=style&index=0&id=489ea91a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489ea91a"]])

export default __exports__